import type { ReadonlySignal } from "@preact/signals";
import { InputLabel } from "./input-label.js";
import { InputError } from "./input-error.js";
import { inputClass, type FieldProps } from "./shared.js";
import { autocompleteFor } from "../../autofill.js";
import type { FormEmbedField } from "../../types.js";

interface SelectProps {
  field: FormEmbedField;
  input: ReadonlySignal<any>;
  errors: ReadonlySignal<[string, ...string[]] | null>;
  props: FieldProps;
  disabled: boolean;
}

export function Select({ field, input, errors, props, disabled }: SelectProps) {
  const errorClass = errors.value ? "border-theme-destructive" : "border-theme-input";

  return (
    <div class={`flex flex-col gap-1 ${field.width === "half" ? "w-[calc(50%-6px)]" : "w-full"}`} data-fv-field={field.name}>
      <InputLabel label={field.label} required={field.required} description={field.description} />
      <select
        {...props}
        class={`${inputClass} ${errorClass}`}
        autocomplete={autocompleteFor(field)}
        value={input}
        disabled={disabled}
        aria-invalid={!!errors.value}
        aria-errormessage={`${props.name}-error`}
      >
        <option value="" disabled hidden selected={!input.value}>
          {field.placeholder ?? "Select an option..."}
        </option>
        {field.options?.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      <InputError name={props.name} errors={errors} />
    </div>
  );
}
